import {
    Box,
    Text,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Button,
    Input,
    InputGroup,
    InputRightElement,
    Flex,
    TableContainer,
    VStack,
    useBreakpointValue,
} from "@chakra-ui/react";
import { FiSearch, FiEye } from "react-icons/fi";
import { useState } from "react";
import Navbar from "../../Navbar/Navbar";
import Sidebar from "../../Sidebar";
import { Link } from "react-router-dom";

/* -------- Dummy Data (Replace with API) -------- */
const bettors = Array.from({ length: 32 }, (_, i) => ({
    id: i + 1,
    name: `Ken Xin`,
    username: `@kenxin8888`,
    email: `[Email is Protected for the demo]`,
    mobile: `[Mobile is protected for the demo]`,
    country: i % 2 === 0 ? "AF" : "US",
    joined: "2026-01-22 08:11 AM",
    ago: `6 hours ago`,
    balance: "₹0.00",
}));

const SIDEBAR_WIDTH = "240px";
const ITEMS_PER_PAGE = 8;

export default function AllBettors() {
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const isMobile = useBreakpointValue({ base: true, md: false });

    const filtered = bettors.filter(
        (b) =>
            b.name.toLowerCase().includes(search.toLowerCase()) ||
            b.username.toLowerCase().includes(search.toLowerCase())
    );

    const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
    const data = filtered.slice(
        (page - 1) * ITEMS_PER_PAGE,
        page * ITEMS_PER_PAGE
    );

    return (
        <>
            <Navbar />
            <Sidebar />
            <Box
                p={{ base: 4, md: 8 }}
                bg="#f8f9fd"
                minH="100vh"
                mt="80px"
                ml={{ base: 0, md: SIDEBAR_WIDTH }}
            >
                {/* HEADER */}
                <Flex
                    direction={{ base: "column", md: "row" }}
                    justify="space-between"
                    mb={6}
                    align={{ base: "flex-start", md: "center" }}
                    gap={4}
                >
                    <Box>
                        <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="700" color="#32325d" mb={1}>
                            All Bettors
                        </Text>
                    </Box>

                    <InputGroup maxW={{ base: "100%", md: "350px" }} size="md">
                        <Input
                            placeholder="Username / Email"
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(1);
                            }}
                            bg="white"
                            borderRadius="8px"
                            border="1px solid #e2e8f0"
                            fontSize="sm"
                            height="45px"
                            _focus={{
                                borderColor: "#5e72e4",
                                boxShadow: "0 0 0 1px #5e72e4",
                            }}
                        />
                        <InputRightElement h="45px">
                            <Button
                                bg="#5e72e4"
                                color="white"
                                size="sm"
                                borderRadius="6px"
                                _hover={{ bg: "#4e62d4" }}
                                px={4}
                            >
                                <FiSearch />
                            </Button>
                        </InputRightElement>
                    </InputGroup>
                </Flex>

                {/* MOBILE CARD VIEW */}
                {isMobile ? (
                    <VStack spacing={4} align="stretch">
                        {data.map((b) => (
                            <Box
                                key={b.id}
                                bg="white"
                                borderRadius="12px"
                                p={4}
                                boxShadow="0 2px 4px rgba(0, 0, 0, 0.05)"
                                border="1px solid #f0f2f5"
                            >
                                <Flex justify="space-between" align="flex-start" mb={3}>
                                    <Text fontSize="sm" fontWeight="700" color="#32325d">
                                        Bettor
                                    </Text>
                                    <VStack align="flex-end" spacing={0}>
                                        <Text fontSize="md" fontWeight="700" color="#32325d">
                                            {b.name}
                                        </Text>
                                        <Text fontSize="sm" color="#5e72e4" fontWeight="600">
                                            {b.username}
                                        </Text>
                                    </VStack>
                                </Flex>

                                <Flex justify="space-between" py={2} borderTop="1px solid #f0f2f5">
                                    <Text fontSize="sm" fontWeight="700" color="#32325d">
                                        Email-Mobile
                                    </Text>
                                    <VStack align="flex-end" spacing={0}>
                                        <Text fontSize="xs" color="#8898aa" textAlign="right">
                                            {b.email}
                                        </Text>
                                        <Text fontSize="xs" color="#8898aa" textAlign="right">
                                            {b.mobile}
                                        </Text>
                                    </VStack>
                                </Flex>

                                <Flex justify="space-between" py={2} borderTop="1px solid #f0f2f5">
                                    <Text fontSize="sm" fontWeight="700" color="#32325d">
                                        Country
                                    </Text>
                                    <Text fontSize="md" fontWeight="600" color="#525f7f">
                                        {b.country}
                                    </Text>
                                </Flex>

                                <Flex justify="space-between" py={2} borderTop="1px solid #f0f2f5">
                                    <Text fontSize="sm" fontWeight="700" color="#32325d">
                                        Joined At
                                    </Text>
                                    <VStack align="flex-end" spacing={0}>
                                        <Text fontSize="xs" color="#32325d" fontWeight="600">
                                            {b.joined}
                                        </Text>
                                        <Text fontSize="xs" color="#8898aa">
                                            {b.ago}
                                        </Text>
                                    </VStack>
                                </Flex>

                                <Flex justify="space-between" py={2} borderTop="1px solid #f0f2f5">
                                    <Text fontSize="sm" fontWeight="700" color="#32325d">
                                        Balance
                                    </Text>
                                    <Text fontSize="md" fontWeight="700" color="#32325d">
                                        {b.balance}
                                    </Text>
                                </Flex>

                                <Flex justify="space-between" pt={2} borderTop="1px solid #f0f2f5">
                                    <Text fontSize="sm" fontWeight="700" color="#32325d">
                                        Action
                                    </Text>
                                    <Button
                                        as={Link}
                                        to={`/all-bettors/${b.id}`}
                                        size="sm"
                                        variant="outline"
                                        colorScheme="blue"
                                        leftIcon={<FiEye />}
                                        borderRadius="8px"
                                        fontSize="xs"
                                        fontWeight="600"
                                        px={4}
                                    >
                                        Details
                                    </Button>
                                </Flex>
                            </Box>
                        ))}
                    </VStack>
                ) : (
                    /* DESKTOP TABLE VIEW */
                    <Box
                        bg="white"
                        borderRadius="20px"
                        boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.05)"
                        overflow="hidden"
                        border="1px solid #f0f2f5"
                    >
                        <TableContainer>
                            <Table variant="simple">
                                <Thead bg="#f6f9fc">
                                    <Tr>
                                        <Th color="#8898aa" fontSize="xs" py={5} textTransform="uppercase">Bettor</Th>
                                        <Th color="#8898aa" fontSize="xs" py={5} textTransform="uppercase">Email-Mobile</Th>
                                        <Th color="#8898aa" fontSize="xs" py={5} textTransform="uppercase">Country</Th>
                                        <Th color="#8898aa" fontSize="xs" py={5} textTransform="uppercase">Joined At</Th>
                                        <Th color="#8898aa" fontSize="xs" py={5} textTransform="uppercase">Balance</Th>
                                        <Th color="#8898aa" fontSize="xs" py={5} textTransform="uppercase">Action</Th>
                                    </Tr>
                                </Thead>

                                <Tbody>
                                    {data.map((b) => (
                                        <Tr key={b.id} _hover={{ bg: "#fcfdfe" }} transition="background 0.2s">
                                            <Td py={4}>
                                                <Box>
                                                    <Text fontWeight="700" fontSize="sm" color="#32325d">{b.name}</Text>
                                                    <Text color="#5e72e4" fontSize="xs" fontWeight="600">{b.username}</Text>
                                                </Box>
                                            </Td>

                                            <Td py={4}>
                                                <Text color="#8898aa" fontSize="xs" fontWeight="500">{b.email}</Text>
                                                <Text color="#8898aa" fontSize="xs" fontWeight="500">{b.mobile}</Text>
                                            </Td>

                                            <Td py={4}>
                                                <Text fontWeight="600" color="#525f7f" fontSize="sm">{b.country}</Text>
                                            </Td>

                                            <Td py={4}>
                                                <Text color="#32325d" fontSize="xs" fontWeight="600">{b.joined}</Text>
                                                <Text color="#8898aa" fontSize="xs" fontWeight="500">{b.ago}</Text>
                                            </Td>

                                            <Td py={4}>
                                                <Text fontWeight="700" color="#32325d" fontSize="sm">{b.balance}</Text>
                                            </Td>

                                            <Td py={4}>
                                                <Button
                                                    as={Link}
                                                    to={`/all-bettors/${b.id}`}
                                                    size="sm"
                                                    variant="outline"
                                                    colorScheme="blue"
                                                    leftIcon={<FiEye />}
                                                    borderRadius="8px"
                                                    fontSize="xs"
                                                    fontWeight="600"
                                                    _hover={{ bg: "#5e72e4", color: "white" }}
                                                >
                                                    Details
                                                </Button>
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Box>
                )}

                {/* PAGINATION */}
                <Flex justify="center" mt={6} gap={2} flexWrap="wrap">
                    <Button
                        size="sm"
                        variant="ghost"
                        onClick={() => setPage(page - 1)}
                        isDisabled={page === 1}
                        borderRadius="8px"
                        color="#8898aa"
                        fontSize="xs"
                    >
                        Previous
                    </Button>

                    {[...Array(Math.min(totalPages, 5))].map((_, i) => (
                        <Button
                            key={i}
                            size="sm"
                            onClick={() => setPage(i + 1)}
                            bg={page === i + 1 ? "#5e72e4" : "white"}
                            color={page === i + 1 ? "white" : "#8898aa"}
                            borderRadius="8px"
                            border="1px solid #e2e8f0"
                            _hover={{ bg: page === i + 1 ? "#4e62d4" : "#f6f9fc" }}
                            minW="35px"
                            fontSize="xs"
                        >
                            {i + 1}
                        </Button>
                    ))}

                    <Button
                        size="sm"
                        variant="ghost"
                        onClick={() => setPage(page + 1)}
                        isDisabled={page === totalPages}
                        borderRadius="8px"
                        color="#8898aa"
                        fontSize="xs"
                    >
                        Next
                    </Button>
                </Flex>
            </Box>
        </>
    );
}
